import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import AccordionDetails from '@mui/material/AccordionDetails';
import Item from './Item';

const accordionDetailsStyles = {
  backgroundColor: 'surface.white',
  px: 3,
  py: 0,
};

// propOrDashes :: String -> Object -> String
const propOrDashes = R.propOr('--');

const CustomRecipe = ({ compartment }) => {
  const { loadType, supplier, loadingControl, recipe, destination, volume } = compartment;

  const formattedVolume = R.isEmpty(volume) ? '--' : `${volume} Gallons`;

  return (
    <AccordionDetails sx={accordionDetailsStyles}>
      <Item label="Load Type" value={propOrDashes('name', loadType)} />
      <Item label="Supplier" value={propOrDashes('supplierId', supplier)} />
      {R.propEq('hasLoadingControls', true, supplier) && (
        <Item
          label="Loading Control Number/PETROEX"
          value={propOrDashes('loadingControlNumber', loadingControl)}
        />
      )}
      <Item label="Recipe" value={recipe ? `${recipe.recipeId}: ${recipe.name}` : '--'} />

      <Item label="Destination" value={propOrDashes('name', destination)} />
      <Item label="Volume" value={formattedVolume} />
    </AccordionDetails>
  );
};
CustomRecipe.propTypes = {
  compartment: PropTypes.shape({
    destination: PropTypes.shape({}),
    loadType: PropTypes.shape({}),
    loadingControl: PropTypes.shape({}),
    recipe: PropTypes.shape({
      name: PropTypes.string,
      recipeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    supplier: PropTypes.shape({}),
    volume: PropTypes.string,
  }).isRequired,
};

export default CustomRecipe;
